import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 59BABD0B-E745-4389-B318-4E166F2ED0C0
 * name dock-left
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dock-left.svg
 * tags
 */
export const DockLeftIcon = createSvgIcon(<><path d="M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 18H9V6H20Z" /></>, 'DockLeftIcon');
export default DockLeftIcon